// Runs on every page.
//
// Every module here is DOM-guarded: it looks for its own markup and returns
// quietly when the page doesn't have it, so it is safe site-wide. Page-specific
// work belongs in a sibling file and gets routed from ../index.js.
import { initLenis } from '../modules/lenis.js';
import { initNavMenu } from '../modules/nav-menu.js';
import { initNavForm } from '../modules/nav-form.js';
import { initHeaderInk } from '../modules/header-ink.js';
import { initHeroTitle } from '../modules/hero-title.js';
import { initMarqueeLogos } from '../modules/marquee-logos.js';
import { initSlider } from '../modules/slider.js';
import { initTabs } from '../modules/tabs.js';
import { initTeamCarousel } from '../modules/team-carousel.js';
import { initTeamPassions } from '../modules/team-passions.js';
import { initValuesReveal } from '../modules/values-reveal.js';
import { initVimeo } from '../modules/vimeo.js';
import { initLazyVideo } from '../modules/lazy-video.js';

export function initGlobal() {
  initLenis();
  initNavMenu();
  initNavForm();
  initHeaderInk();
  initHeroTitle();
  initMarqueeLogos();
  initSlider();
  initTabs();
  initTeamCarousel();
  initTeamPassions();
  initValuesReveal();
  initVimeo();
  initLazyVideo();
}
